import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuthStore } from "@/stores/authStore";

export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, user, loadMe } = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated && !user) {
      loadMe();
    }
  }, [isAuthenticated, user, loadMe]);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  // Pending-User (registriert, noch nicht freigeschaltet) dürfen sich seit
  // der Lizenz-Aktivierung einloggen, landen aber immer auf /activate —
  // Kauf = Freischaltung. Der Admin-Approve-Pfad bleibt unverändert.
  if (user && user.status === "pending" && location.pathname !== "/activate") {
    return <Navigate to="/activate" replace />;
  }
  return <>{children}</>;
}
